module.exports = __webpack_public_path__ + "static/hzszyy-18717881ce3698803a3c9581e4536998.jpg";